<template>
    <div class="modal fade" data-backdrop="static" id="add-new-plant" tabindex="-1" role="dialog" aria-labelledby="modal-block-vcenter" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="block block-themed block-transparent mb-0">
            <div class="block-header bg-info bg-light">
              <h3 class="block-title"><i class="fa fa-angle-double-right"></i> Add New Plant</h3>
              <div class="block-options">
                <button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close" @click.prevent="clearData()">
                  <i class="fa fa-fw fa-times"></i>
                </button>
              </div>
            </div>
            <transition name="slide-fade">
              <div class="text-center alert-message-top" v-if="errorMsg">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <div class="alert-message alert-danger alert-error-message">{{errorMsg}}</div>
                </div>
              </div>
            </transition>
            <div class="block-content">
              <div class="form-group required">
                <label class="control-label">Plant Batch Name</label>
                <input v-model="name" name="plantbatch_name" type="text" class="form-control form-control-alt" v-validate="'required'" data-vv-as="Plantbatch Name" placeholder="Name" />
                <p v-if="errors.has('plantbatch_name')" class="errorMsg">{{ errors.first('plantbatch_name') }}</p>
              </div>
              <div class="form-group required">
                <label class="control-label">Count</label>
                <input v-model="count" name="count" id="plant_count"  type="number" onkeypress="return event.charCode >= 48" min="1" class="form-control form-control-alt" placeholder="Count" />
                <p v-if="countError" class="errorMsg">The Count field is required and it should be positive number.</p>
              </div>
              <div class="form-group required">
                <label class="control-label">Starting Tag</label>
                <input v-model="startingTag" name="starting_tag" type="text" class="form-control form-control-alt" v-validate="'required'" data-vv-as="Starting Tag" placeholder="Starting Tag" />
                <p v-if="errors.has('starting_tag')" class="errorMsg">{{ errors.first('starting_tag') }}</p>
              </div>
              <div class="form-group required">
                <label class="control-label">Growth Phase</label>
                <select id="add-plant-phase" class="form-control form-control-alt select2-dropdown" style="width: 100%;" placeholder="Select Growth phase..">
                  <option></option>
                  <option :value="phase" v-for="(phase, index) in library.growthPhases" :key="index">{{ phase }}</option>
                </select>
                <p v-if="phaseError" class="errorMsg">The Growthphase field is required.</p>
              </div>
              <div class="form-group required">
                <label class="control-label">New Room</label>
                <select id="add-plant-room" class="form-control form-control-alt select2-dropdown" style="width: 100%;" placeholder="Select Room..">
                  <option></option>
                  <option :value="room.Name" v-for="(room, index) in library.rooms" :key="index">{{ room.Name }}</option>
                </select>
                <p v-if="roomError" class="errorMsg">The Room field is required.</p>
              </div>
              <div class="form-group">
                <label>Growth Date</label>
                <input v-model="date" id="plant-date" type="text" class="form-control form-control-alt datepicker" />
              </div>
            </div>
            <div class="block-content block-content-full text-right border-top button-loader">
              <button type="button" class="btn btn-sm btn-light" data-dismiss="modal" @click.prevent="clearData()">Close</button>
              <button type="button" class="btn btn-sm btn-primary" @click.prevent="addNewPlant()" :bind:disabled="showModalLoader">
                  <div><i class="fa fa-save mr-1"></i><span>Save</span></div>
                  <span class="modal-loader" v-if="showModalLoader">
                    <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="15" sizeUnit="px"></hash-loader>
                  </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import { mapState, mapActions } from 'vuex';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
import { helper } from '@/helper.js';
import $ from 'jquery';
import * as select2 from 'select2/dist/js/select2.full.js';
import 'select2/dist/css/select2.min.css';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css';

Vue.use(VeeValidate, VueSpinners);

export default {
  name: 'AddPlant',
  data() {
    return {
      name: this.plantBatchName,
      count: 1,
      date: new Date().toJSON().slice(0,10),
      startingTag: '',
      growthPhase: '',
      room: '',
      phaseError: false,
      roomError: false,
      errorMsg: '',
      showModalLoader: false,
      countError: false
    };
  },
  mounted() {
    $('.datepicker').datepicker({ format: 'yyyy-mm-dd', autoclose:true });

    let phase = $('#add-plant-phase'), vm = this;
    phase.on('change', function() {
      vm.phaseError = false;
      vm.growthPhase = phase.val();
    });

    let room = $('#add-plant-room');
    room.on('change', function () { vm.roomError = false; vm.room = room.val(); });
    $('#plant-date').change(function() { vm.date = $(this).val(); });
    $('#plant_count').keyup(function() {
      if($(this).val() > 0 && $(this).val() % 1 === 0) {
        vm.countError = false;
      } else {
        vm.countError = true;
      }
    });
  },
  computed: {
    ...mapState({
      library: state => state.library
    })
  },
  components: {
    HashLoader
  },
  methods: {
    ...mapActions('alert', ['success', 'error', 'clear']),
    ...mapActions('library', ['getAllVegetativePlants', 'getAllFloweringPlants']),
    clearData() {
      this.name = '';
      this.count = 1;
      this.startingTag = '';
      this.growthPhase = '';
      this.room = '';
      this.errorMsg = '';
      this.countError = false;
      this.date = new Date().toJSON().slice(0,10);
      $('.select2-dropdown').val(null).trigger('change');
      $('.datepicker').datepicker('update', this.date);
      this.$validator.reset();
    },
    addNewPlant() {
      let vm = this;
      this.$validator.validate().then(valid => {
        if (vm.validateSelectBox() && valid) {
          vm.showModalLoader = true;
          vm.errorMsg = '';
          helper.sendPostRequest('/plantbatches/changegrowthphase', {
            'Name': vm.name,
            'Count': vm.count, 
            'StartingTag': vm.startingTag,
            'GrowthPhase': vm.growthPhase,
            'NewRoom': vm.room,
            'GrowthDate': vm.date
          }).then(function(data) {
            if (data.status === 'success') {
              vm.showModalLoader = false;
              vm.getAllVegetativePlants();
              vm.getAllFloweringPlants();
              jQuery('#add-new-plant').modal('hide');
              vm.clearData();
              vm.$emit('showSuccessMsg', data.message);
            } else {
              vm.errorMsg = data.message;
              vm.showModalLoader = false;
            }
          });
        }
      });
    },
    validateSelectBox() {
      this.phaseError = false;
      this.roomError  = false;
      if (this.growthPhase === '') {
        this.phaseError = true;
      }
      if (this.room === '') {
        this.roomError = true;
      }
      if (this.count <= 0 || this.count % 1 !== 0) {
        this.countError = true;
      }
      if (this.phaseError || this.roomError || this.countError) {
        return false;
      }
      return true;
    },
    setPlantBatchName(name) {
      this.name = name;
    }
  }
};
</script>


// WEBPACK FOOTER //
// source/components/modals/AddPlant.vue